<template>
  <modal
    :open="open"
    :eventName="'openRefresh'"
    @close="closeModal"
  >
    <template slot='header'>
      <h1>{{ $t('auto-logout.title') }}</h1>
    </template>
    <template slot='body'>
      <p>{{ $tc('auto-logout.expiration', expiresInMinutes, { time: expiresInMinutes }) }}</p>

      <div class='btns-container'>
        <x-button class='dark' @click='exit' :disabled='refreshing'>
          {{ $t('auto-logout.logout') }}
        </x-button>
        <x-button class='md-raised md-primary' @click='refresh' :disabled='refreshing'>
          {{ $t('auto-logout.login') }}
        </x-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import modal from '@/components/modal'
  import Cookie from '@/utils/cookie'
  import differenceInSeconds from 'date-fns/difference_in_seconds'

  export default {
    name: 'app-refresh',

    components: {
      'modal': modal
    },

    data () {
      return {
        authExpire: null,
        expiresInMinutes: null,
        open: false,
        refreshing: false,
        interval: null
      }
    },

    mounted () {
      this.start()
    },

    computed: {
      ...mapState({
        authenticated: state => state.auth.authenticated
      })
    },

    methods: {
      ...mapActions({
        refreshToken: 'auth/refreshToken',
        logOut: 'auth/logOut'
      }),

      start () {
        const expiration = Cookie.get('authExpire')

        if (expiration) {
          this.authExpire = new Date(expiration)
          this.interval = setInterval(this.checkExpire, 5000) // 10 min 600000
        }
      },

      checkExpire () {
        const now = new Date()
        const sToExpire = differenceInSeconds(this.authExpire, now)
        this.expiresInMinutes = Math.round(sToExpire / 60)

        if (sToExpire <= 60) {
          this.exit()
        } else if (sToExpire <= 300) { // 5min
          this.open = true
        }
      },

      exit () {
        this.logOut()
          .then(() => {
            this.reset()
            this.$router.push({
              name: 'login'
            })
          })
      },

      refresh () {
        this.refreshing = true
        this.refreshToken()
          .then(() => {
            this.reset()
            this.start()
          })
          .catch(() => {
            this.reset()
          })
      },

      reset () {
        clearInterval(this.interval)
        this.open = false
        this.authExpire = null
        this.expiresInMinutes = null
        this.refreshing = false
        this.interval = null
      },

      closeModal () {
        this.open = false
      }
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    watch: {
      authenticated (val) {
        if (val) {
          this.start()
        } else {
          this.reset()
        }
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  h1 {
    text-align: center;
    font-weight: 600;
    font-size: 2.4rem;
  }

  .btns-container {
    margin-top: $space-big;
    text-align: center;
    display: flex;
    justify-content: space-between;
  }
</style>